import { z } from 'zod';
export const MccSuggestionSchema = z.object({
    mcc: z.string().nullish(),
    description: z.string().nullish(),
    reasoning: z.string().nullish()
});
// Aligns with MerchantCategoryCodeSummarySchema from digital-footprint
export const MccSchema = z.object({
    primary: MccSuggestionSchema.nullable(),
    alternatives: z.array(MccSuggestionSchema).default([])
});
export const ContentAnalysisSchema = z.object({
    lineOfBusiness: z.string().nullish(),
    mcc: MccSchema.nullish(),
    websiteMarkdown: z.string().nullish()
}).meta({
    id: 'ContentAnalysis'
});

//# sourceMappingURL=content-analysis.schema.js.map